<button class="icon-left" mat-icon-button [matMenuTriggerFor]="filterMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #filterMenu="matMenu">
    <div class="filterContent" (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilters()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Clear filter</span>
            </button>
        </div>
        <div class="medium-margin-top">
            <input class="searchInput" [(ngModel)]="search" placeholder="Search..." (ngModelChange)="applyFilter()">
        </div>
    </div>
</mat-menu>
